function toCleanString(value) {
  if (value == null) return "";
  return String(value).trim();
}

function activeExamNamesFromNode(node) {
  if (!node || typeof node !== "object") return [];
  return Object.entries(node)
    .filter(([key, value]) => {
      const examName = toCleanString(key);
      if (!examName || examName.toLowerCase() === "all") return false;
      return value === true;
    })
    .map(([key]) => toCleanString(key))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
}

function stateLabelFromNode(stateKey, stateValue) {
  const fromNode = toCleanString(stateValue?.label || stateValue?.name || stateValue?.title);
  if (fromNode) return fromNode;
  return toCleanString(stateKey);
}

function findStateEntryByLabelOrKey(statesNode, selectedState) {
  const target = toCleanString(selectedState).toLowerCase();
  if (!target || !statesNode || typeof statesNode !== "object") return null;

  for (const [stateKey, stateValue] of Object.entries(statesNode)) {
    const cleanKey = toCleanString(stateKey);
    if (!cleanKey || cleanKey.toLowerCase() === "all") continue;
    const label = stateLabelFromNode(cleanKey, stateValue).toLowerCase();
    if (cleanKey.toLowerCase() === target || label === target) {
      return { stateKey: cleanKey, stateValue: stateValue || {} };
    }
  }

  return null;
}

export function taxonomyStatesWithActiveExams(taxonomy) {
  const statesNode = taxonomy?.states;
  if (!statesNode || typeof statesNode !== "object") return [];

  return Object.entries(statesNode)
    .filter(([stateKey, stateValue]) => {
      const cleanKey = toCleanString(stateKey);
      if (!cleanKey || cleanKey.toLowerCase() === "all") return false;
      return activeExamNamesFromNode(stateValue?.exams).length > 0;
    })
    .map(([stateKey, stateValue]) => stateLabelFromNode(stateKey, stateValue))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
}

export function taxonomyExamsForState(taxonomy, selectedState) {
  const statesNode = taxonomy?.states;
  const selected = findStateEntryByLabelOrKey(statesNode, selectedState);
  if (selected) {
    return activeExamNamesFromNode(selected.stateValue?.exams);
  }

  // Fallback for legacy/global exam structures.
  return activeExamNamesFromNode(taxonomy?.exams || taxonomy?.exam);
}
